import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./app.module";

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./~/angular2-template-loader?keepUrl=true!./app/main.ts